import React from 'react';
import PropTypes from 'prop-types';
import ProfileMetricCard from '../../CandidateComponents/Shards/ProfileMetricCard';
import AdditionalMetricCard from '../../CandidateComponents/Shards/AdditionalMetricCard';
import StrengthsConcernsCard from '../../CandidateComponents/Shards/StrengthsConcernsCard';
import HardSkillsSection from '../../CandidateComponents/Shards/HardSkillsSection';
import SoftSkillsSection from '../../CandidateComponents/Shards/SoftSkillsSection';
import SpokenLanguageSummary from '../../CandidateComponents/Shards/SpokenLanguageSummary';
import AreasOfExpertise from '../../CandidateComponents/Shards/AreasOfExpertise';
import JobResponsibilitiesFit from '../../CandidateComponents/Shards/JobResponsibilitiesFit';

/**
 * CandidateEvaluationReportContent Component
 * Custom evaluation report content for the public report
 */
const CandidateEvaluationReportContent = ({ candidate }) => {
  // Check if we have evaluation data
  const hasEvaluationData = !!candidate?.job_evals_report_json;

  if (!hasEvaluationData) {
    return (
      <div className="p-6">
        <div className="text-center text-gray-500 py-8">
          <div className="bg-blue-50 rounded-full p-6 mb-4 inline-block">
            <svg className="w-16 h-16 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">No Evaluation Data Available</h3>
          <p className="text-gray-600">Evaluation report data is not available for this candidate.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Conclusion and Charts Section */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> */}
        {/* Left column - Conclusion */}
        {/* <div className="border border-blue-200 rounded-lg p-6 bg-blue-50 relative">
          <div className="flex justify-between items-start mb-3">
            <h4 className="text-lg font-semibold text-gray-800">Conclusion</h4>
            {candidate?.job_evals_report_json?.conclusion?.source && (
              <span className="text-xs text-gray-500">Source: {candidate.job_evals_report_json.conclusion.source}</span>
            )}
          </div>
          <div className="h-full">
            <p className="text-gray-800 text-lg">{candidate?.job_evals_report_json?.conclusion?.value || "No conclusion available."}</p>
          </div>
        </div> */}
        
        {/* Right column - Charts */}
        {/* <div className="space-y-6"> */}
          {/* General Ability Chart */}
          {/* <ProfileMetricCard
            title="General Ability"
            value={candidate?.job_evals_report_json?.generalAbility?.value || 0}
            rationale={candidate?.job_evals_report_json?.generalAbility?.rationale}
            source={candidate?.job_evals_report_json?.generalAbility?.source}
          /> */}
          
          {/* Job Fit Chart */}
          {/* <ProfileMetricCard
            title="Job Fit"
            value={candidate?.job_evals_report_json?.jobFit?.value || 0}
            rationale={candidate?.job_evals_report_json?.jobFit?.rationale}
            source={candidate?.job_evals_report_json?.jobFit?.source}
          />
        </div>
      </div> */}
      
      {/* Additional Key Metrics Section */}
      {(candidate?.job_evals_report_json?.["AI Proficiency"] || candidate?.job_evals_report_json?.["Multidisciplinary Expertise"] || candidate?.job_evals_report_json?.["Security Awareness"]) && (
        <div className="border border-gray-200 rounded-lg p-6 bg-white">
          <h4 className="text-xl font-semibold text-gray-800 mb-4">Additional Key Metrics</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* AI Proficiency */}
            {candidate?.job_evals_report_json?.["AI Proficiency"] && (
              <AdditionalMetricCard 
                title="AI Proficiency"
                value={candidate.job_evals_report_json["AI Proficiency"].value || 0}
                rationale={candidate.job_evals_report_json["AI Proficiency"].rationale}
                source={candidate.job_evals_report_json["AI Proficiency"].source}
              />
            )}
                        
            {/* Security Awareness */}
            {candidate?.job_evals_report_json?.["Security Awareness"] && (
              <AdditionalMetricCard 
                title="Security Awareness"
                value={candidate.job_evals_report_json["Security Awareness"].value || 0}
                rationale={candidate.job_evals_report_json["Security Awareness"].rationale}
                source={candidate.job_evals_report_json["Security Awareness"].source}
              />
            )}

            {/* Multidisciplinary Expertise */}
            {candidate?.job_evals_report_json?.["Multidisciplinary Expertise"] && (
              <AdditionalMetricCard 
                title="Multidisciplinary Expertise"
                value={candidate.job_evals_report_json["Multidisciplinary Expertise"].value || 0}
                rationale={candidate.job_evals_report_json["Multidisciplinary Expertise"].rationale}
                source={candidate.job_evals_report_json["Multidisciplinary Expertise"].source}
              />
            )}

          </div>
        </div>
      )}

      {/* Strengths and Concerns Section */}
      {(candidate?.job_evals_report_json?.strengths?.items || candidate?.job_evals_report_json?.concerns?.items) && (
        <StrengthsConcernsCard 
          strengths={{...candidate?.job_evals_report_json?.strengths, value: candidate?.job_evals_report_json?.strengths?.items}}
          concerns={{...candidate?.job_evals_report_json?.concerns, value: candidate?.job_evals_report_json?.concerns?.items}}
        />
      )}

      {/* Hard Skills Section */}
      {(candidate?.eval_hardskills_json?.hardSkills || candidate?.job_evals_report_json?.hardSkills) && (
        <HardSkillsSection 
          hardSkills={{ 
            value: candidate?.eval_hardskills_json?.hardSkills.items || candidate?.job_evals_report_json?.hardSkills.items, 
            source: "Evaluation" 
          }}
          radarChartMode="required"
        />
      )}

      {/* Soft Skills Section */}
      {candidate?.eval_softskills_json && (
        <SoftSkillsSection softSkills={{ value: candidate.eval_softskills_json, source: "Resume, Evals" }} />
      )}

      {/* Spoken Languages Section */}
      {candidate?.eval_language_json && candidate.eval_language_json.length > 0 && (
        <div className="border border-gray-200 rounded-lg p-6 bg-white">
          <SpokenLanguageSummary spokenLanguageData={candidate.eval_language_json} />
        </div>
      )}

      {/* Areas of Expertise Section */}
      {candidate?.job_evals_report_json?.expertise?.value && (
        <AreasOfExpertise expertise={candidate.job_evals_report_json.expertise} />
      )}

      {/* Job Responsibilities Fit Section */}
      {candidate?.job_evals_report_json?.responsibilitiesFit?.value && (
        <JobResponsibilitiesFit responsibilitiesFit={candidate.job_evals_report_json.responsibilitiesFit} />
      )}
    </div>
  );
};

CandidateEvaluationReportContent.propTypes = {
  candidate: PropTypes.object.isRequired
};

export default CandidateEvaluationReportContent;
